import { useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { isDevMode } from '../utils/devMode'
import { redirectToClub4x4Website } from '../utils/portalMarketingRedirect'
import { hasPortalReturningUser } from '../utils/portalReturningUser'
import { isPortalRootSignInRedirect } from '../utils/portalRuntimeConfig'
import { MARKETING_LOGIN_QUERY } from '../utils/marketingAuthEntry'
import { usePortalAuth } from '../auth/authContexts'
import LandingPage from './LandingPage'
import PostLoginLoadingScreen from './PostLoginLoadingScreen'

/**
 * Portal `/` route: full-mock landing page when not forcing portal sign-in;
 * production sends anonymous first-time visitors to the self-service hub and
 * returning users to Auth0 login (`/signin?login=1`).
 * When `PORTAL_ROOT_SIGNIN=true` on the web app (staging), or on localhost /
 * Vite `VITE_PORTAL_ROOT_SIGNIN`, anonymous `/` goes to `/signin` instead of
 * marketing — including when `VITE_LOCAL_FULL_MOCK=true` (do not let mock mode
 * bypass that redirect).
 */
export default function PortalRootEntry() {
  const { isAuthenticated, isLoading } = usePortalAuth()
  const navigate = useNavigate()

  useLayoutEffect(() => {
    if (isLoading || isAuthenticated) {
      return
    }
    if (isPortalRootSignInRedirect()) {
      navigate('/signin', { replace: true })
      return
    }
    if (isDevMode()) {
      return
    }
    if (hasPortalReturningUser()) {
      navigate(`/signin?${MARKETING_LOGIN_QUERY}=1`, { replace: true })
      return
    }
    redirectToClub4x4Website()
  }, [isAuthenticated, isLoading, navigate])

  if (isDevMode() && !isPortalRootSignInRedirect()) {
    return <LandingPage />
  }

  return <PostLoginLoadingScreen />
}
